/* global $:true plyr:true */

import debug from "debug";

import { MODULE_NAME } from './index';
import googleMapsApiPromise from '../../services/google-maps-api';
import debounce from '../../lib/debounce';

const log = debug(MODULE_NAME);

export class StoreLocatorSearch {

    constructor(element, options) {
        this.element = element;
        this.$element = $(element);
        this.$form = this.$element;
        this.options = options;

        if (this.element.nodeName != 'form') {
            this.$form = this.$element.find(this.options.formSelector);
        }

        log('construct', this.element, this.options);

        this.$addressField = this.$element.find(this.options.addressFieldSelector);
        this.$addressGoogleComponent = this.$element.find(this.options.addressGoogleComponentSelector);
        this.$submitButton = this.$element.find(this.options.submitButtonSelector);
        this.$latField = this.$element.find(`[${this.options.latLngKeyAttribute}="lat"]`);
        this.$lngField = this.$element.find(`[${this.options.latLngKeyAttribute}="lng"]`);

        this.place = {};

        googleMapsApiPromise.then(this.init.bind(this));

    }

    init () {
        log('init');
        this.$form.on('submit', this.onSubmit.bind(this));
        this.$addressGoogleComponent.on('keypress', debounce(this.onKeyPress.bind(this), 150));
        this.$addressGoogleComponent.on('place_selected', this.onPlaceSelected.bind(this));

    }

    onKeyPress (event) {
        switch (event.keycode) {
            case 13:
                event.preventDefault();
                break;

            default:
                this.setFormLatLngValues('',''); //blanks out the form field values
                break;
        }
    }

    onPlaceSelected (event) {

        if (!this.submitOnchange) {
            log('place_selected.preventDefault', event);
            event.preventDefault && event.preventDefault();
        }

        const {place} = event;
        if (!place || !place.location) return;

        this.setSelectedPlace(place);

        if (this.submitOnchange) {
            this.$form.submit();
        }

    }

    onSubmit (event) {
        this.$submitButton.addClass('has-progress');
    }

    setFormLatLngValues(lat, lng) {
        this.$latField.get(0).value = lat || '';
        this.$lngField.get(0).value = lng || '';
    }

    setSelectedPlace(place) {
        this.place = place;
        const {lat, lng} = this.getSelectedLatLng(place);
        log('setSelectedPlace', {name: this.$addressField.val(), lat, lng});
        this.setFormLatLngValues(lat, lng);
    }

    getSelectedLatLng (place) {
        if (!place) {
            return {};
        }
        const {lat, lng} = place.location;
        return {
            lat: lat(),
            lng: lng(),
        };
    }

}

StoreLocatorSearch.DEFAULTS = {
    submitOnchange: false,
    addressFieldSelector: '.store-locator-search__address-field',
    submitButtonSelector: '.store-locator-search__submit-button',
    latLngKeyAttribute: 'data-store-locator-search-latlng', // also used to build the selector
    formSelector: 'form',
};



// WEBPACK FOOTER //
// ./project/client/src/core/modules/store-locator-search/component.js